export default __webpack_public_path__ + "static/media/filter_icon_toilet_blue.3084f2cd.svg";